import React from "react";
import { PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { PageHeader } from "../../components";
import { useSectionAccess } from "../../Services";
import { ProductAction } from "../../Types";
import { useStockTransfer } from "./common/useStockTransfer";
import {
  NewTransferDrawer,
  StockTransferFilters,
  StockTransfersTable,
  TransferDetailDrawer,
} from "./common";

export const StockTransferPage = () => {
  const {
    page,
    setPage,
    searchInput,
    setSearchInput,
    filterFromStore,
    setFilterFromStore,
    filterToStore,
    setFilterToStore,
    newDrawerOpen,
    setNewDrawerOpen,
    selectedTransfer,
    setSelectedTransfer,
    form,
    fromStoreId,
    selectedProductId,
    selectedStockId,
    transferQty,
    transferItems,
    transfers,
    total,
    isLoading,
    refetch,
    stores,
    products,
    setProductSearch,
    isProductsLoading,
    selectedProduct,
    selectedStock,
    isSubmitting,
    handleCloseNewDrawer,
    handleProductChange,
    handleAddTransferItem,
    handleRemoveTransferItem,
    handleCreateTransferSubmit,
    setSelectedStockId,
    setTransferQty,
  } = useStockTransfer();
  const { isAllowed } = useSectionAccess("products");

  return (
    <div className="p-6 min-h-screen bg-gray-50">
      <PageHeader
        title="Stock Transfer"
        subText="Exchange and transfer product stocks between stores."
        handleButtons={[
          { icon: ReloadOutlined, onClick: refetch, title: "Refresh" },
          ...(isAllowed(ProductAction.Transfer) ? [{
            icon: PlusOutlined,
            onClick: () => setNewDrawerOpen(true),
            title: "New Transfer",
          }] : []),
        ]}
        searchBar={
          <StockTransferFilters
            searchInput={searchInput}
            onSearchChange={(v) => {
              setSearchInput(v);
              setPage(1);
            }}
            stores={stores}
            filterFromStore={filterFromStore}
            onFromStoreChange={setFilterFromStore}
            filterToStore={filterToStore}
            onToStoreChange={setFilterToStore}
          />
        }
      />

      <StockTransfersTable
        transfers={transfers}
        total={total}
        page={page}
        isLoading={isLoading}
        onPageChange={setPage}
        onView={setSelectedTransfer}
      />

      <NewTransferDrawer
        open={newDrawerOpen}
        form={form}
        stores={stores}
        fromStoreId={fromStoreId}
        products={products}
        isProductsLoading={isProductsLoading}
        selectedProductId={selectedProductId}
        selectedProduct={selectedProduct}
        selectedStockId={selectedStockId}
        transferQty={transferQty}
        transferItems={transferItems}
        isSubmitting={isSubmitting}
        onClose={handleCloseNewDrawer}
        onSubmit={handleCreateTransferSubmit}
        onProductSearch={setProductSearch}
        onProductChange={handleProductChange}
        onStockChange={setSelectedStockId}
        onQtyChange={setTransferQty}
        onAddItem={handleAddTransferItem}
        onRemoveItem={handleRemoveTransferItem}
      />

      <TransferDetailDrawer
        transfer={selectedTransfer}
        onClose={() => setSelectedTransfer(null)}
      />
    </div>
  );
};
